import { lazy } from 'react';
import {
  type Icon,
  ArrowsLeftRight,
  Book,
  BookOpen,
  BookOpenText,
  Books,
  ClockCounterClockwise,
  CurrencyJpy,
  Download,
  House,
  IconWeight,
  PuzzlePiece,
  Robot,
  Upload,
  User,
} from '@phosphor-icons/react';

export interface RouteCfgType {
  path: string;
  text: string;
  /** 手机端底部导航使用的短文案，缺省时回退到 text */
  mobileText?: string;
  icon: Icon;
  element: React.FC | null;
  href?: string; // 外部链接
  active?: boolean;
  hideInMenu?: boolean;
  iconProps?: {
    weight?: IconWeight;
  };
  badgeProps?: {
    text: string;
    color?: string;
  };
  links?: {
    text: string;
    icon: Icon;
    href: string;
  }[]; // 下拉菜单链接
}

export const LoginRoute = lazy(() => import('~/pages/Login'));

export const RoutesCfg: RouteCfgType[] = [
  {
    path: '/home',
    text: '首页',
    mobileText: '首页',
    icon: House,
    badgeProps: {
      text: '新',
    },
    element: lazy(() => import('~/pages/Home')),
    active: true,
  },
  {
    path: '/download',
    text: '剪映小助手',
    mobileText: '剪映',
    icon: Download,
    element: lazy(() => import('~/pages/Download')),
    hideInMenu: true,
  },
  {
    path: '/workflow/migration',
    text: '工作流迁移',
    mobileText: '迁移',
    icon: ArrowsLeftRight,
    iconProps: { weight: 'bold' },
    element: lazy(() => import('~/pages/WorkflowMgr/Migration')),
  },
  {
    path: '/workflow',
    text: '工作流商店',
    mobileText: '工作流',
    icon: Robot,
    iconProps: { weight: 'fill' },
    element: lazy(() => import('~/pages/WorkflowMgr')),
  },
  {
    path: '/recharge',
    text: '增值服务',
    mobileText: '增值',
    icon: CurrencyJpy,
    iconProps: { weight: 'bold' },
    element: lazy(() => import('~/pages/Packages')),
  },
  {
    path: '/jcaigc-doc',
    text: '技术文档',
    mobileText: '文档',
    icon: Books,
    element: null,
    links: [
      {
        text: '官方文档',
        icon: Book,
        href: 'https://jcaigc-doc.feishu.cn/wiki/FlYEwlKusiC6lZkjLcocqZ0LnKe',
      },
      {
        text: 'API文档',
        icon: BookOpenText,
        href: 'https://docs.jcaigc.cn/',
      },
      {
        text: '插件列表',
        icon: PuzzlePiece,
        href: 'https://www.coze.cn/user/1388063163427228?access_entrance=my_profile&sub_tab=plugins&tab=user_product',
      },
    ],
  },
  {
    path: '/user-info',
    text: '个人中心',
    mobileText: '我的',
    hideInMenu: true,
    icon: User,
    element: lazy(() => import('~/pages/UserInfo')),
  },
  {
    path: '/upload',
    text: '上传文件',
    icon: Upload,
    hideInMenu: true,
    element: lazy(() => import('~/pages/UploadFile')),
  },
  {
    path: '/balance-log',
    text: '消费明细',
    icon: ClockCounterClockwise,
    hideInMenu: true,
    element: lazy(() => import('~/pages/BalanceLog')),
  },
  {
    path: '/workflow/bot/:id',
    text: '工作流详情',
    icon: BookOpen,
    hideInMenu: true,
    element: lazy(() => import('~/pages/WorkflowMgr/Bots/Bot/$id')),
  },
  {
    path: '/external-features',
    text: '剪映小助手特性',
    icon: Download,
    hideInMenu: true,
    element: lazy(() => import('~/pages/ExternalFeatures')),
  },
];
